import React from 'react';
// Constants
import { KeywordsPages, LocationCity, MainTitle } from '../../utils/Constants';
// Data
import {
  aboutMePageStructuredData,
  aboutMePageAdditionalMeta,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import GeneralHeader from '../../components/general/GeneralHeader';
import AboutMemainContainer from '../../components/about/AboutMemainContainer';
// Images
import FlowerBanner from '../../assets/images/temp/flower-banner-background.svg';
import SammiMainImage from '../../assets/images/noBackground/mistress-sammi-smith-trans-dominatrix-no-background-full-body-small.png';
import AboutMeHeaderMobile from '../../assets/images/headers/about-misress-sammi-page-header-mobile.png';
import AboutMeHeaderMain from '../../assets/images/headers/about-misress-sammi-page-header.png';

function AboutMePage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='About Me'
        desc={`Discover more about Mistress Sammi Smith, a powerful and seductive trans dominatrix in ${LocationCity}. Learn about my experience, specialties, and what to expect.`}
        keywords={KeywordsPages}
        additionalMeta={aboutMePageAdditionalMeta}
        structuredData={aboutMePageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1 w-full h-full font-poppins'>
        <div className='grid h-fit'>
          {/* Navigation */}
          <Navbar />
          <GeneralHeader
            headerMainImage={AboutMeHeaderMain}
            headerMobileImage={AboutMeHeaderMobile}
            mainTitle={`${MainTitle}`}
            subtitle={`My Domination Lifestyle`}
            mainImage={SammiMainImage}
          />
        </div>

        {/* Main page content */}
        <AboutMemainContainer />

        <div
          style={{
            backgroundImage: `url(${FlowerBanner})`,
            backgroundSize: 'cover', // Ensures full width coverage
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
          className='grid min-h-[300px] lg:min-h-[500px] pt-20'
        ></div>
      </div>
    </>
  );
}

export default AboutMePage;
